export default __webpack_public_path__ + "static/media/icons8-react-native.ce347639.svg";